import React, { useState, useRef } from 'react'
import { FontFamily, Text } from '@gousto-internal/citrus-react'
import styled from '@emotion/styled'

import { useClickOutside } from '../SwapAlternativeOptions/useClickOutside'
import { RecipeAlternativeOptions } from '../SwapAlternativeOptions/RecipeAlternativeOptions'
import {
  cssButton,
  cssDropWrapperV2,
  cssIsExpanded,
  cssOuterWrapper,
  cssFineDineInButton,
} from './styles'
import { useRecipe } from '../../model/context'
import { useTrackingHook } from '../../model/context/useTracking'
import { useDeviceType, DeviceType } from '@library/dom'

const escapeKeyPressed = (e: React.KeyboardEvent) => {
  return e.type === 'keyup' && e.keyCode && e.keyCode === 27
}

const OptionsButton = styled.div(({ isFineDineIn }: { isFineDineIn?: boolean }) => ({
  ...cssButton,
  ...(isFineDineIn ? cssFineDineInButton : {}),
}))

const DropDown = styled.div<{ showOptions: boolean }>(({ showOptions }) => ({
  ...cssDropWrapperV2,
  ...(showOptions ? cssIsExpanded : null),
}))

const OuterWrapper = styled.div(cssOuterWrapper)

export function SwapAlternativeOptions({
  recipeId,
  originalId,
  categoryId,
  SwapAlternativeOptionsMobile,
}: {
  recipeId: string
  originalId: string
  categoryId: string
  SwapAlternativeOptionsMobile?: React.FC<Record<string, unknown>>
}) {
  const [showOptions, setShowOptions] = useState(false)
  const useTracking = useTrackingHook()
  const { useTrackingSwapAlternativeOptions } = useTracking()
  const { trackRecipeAlternativeOptionsMenuOpen, trackRecipeAlternativeOptionsMenuSwapRecipes } =
    useTrackingSwapAlternativeOptions()
  const deviceType = useDeviceType()
  const { isFineDineIn } = useRecipe()

  const collectionId = categoryId

  const selectRef = useRef(null)
  useClickOutside(selectRef, () => setShowOptions(false), [showOptions])

  if (deviceType === DeviceType.MOBILE && SwapAlternativeOptionsMobile) {
    return <SwapAlternativeOptionsMobile />
  }

  return (
    <OuterWrapper ref={selectRef}>
      <OptionsButton
        data-testid="SwapAlternativeOptionsButton"
        isFineDineIn={isFineDineIn}
        onClick={(e) => {
          e.stopPropagation()
          setShowOptions(!showOptions)

          if (!showOptions) {
            trackRecipeAlternativeOptionsMenuOpen({ recipeId, collectionId })
          }
        }}
        onKeyUp={(e) => {
          e.stopPropagation()

          if (escapeKeyPressed(e)) {
            setShowOptions(false)
          }
        }}
      >
        <Text fontFamily={FontFamily.Bold}>Options</Text>
      </OptionsButton>
      {showOptions && (
        <DropDown aria-hidden={!showOptions} showOptions={showOptions}>
          <RecipeAlternativeOptions
            recipeId={recipeId}
            originalId={originalId}
            categoryId={categoryId}
            onChangeCheckedRecipe={({ previousRecipeId, nextRecipeId }) => {
              trackRecipeAlternativeOptionsMenuSwapRecipes({
                collectionId,
                previousRecipeId,
                nextRecipeId,
              })
              setShowOptions(false)
            }}
          />
        </DropDown>
      )}
    </OuterWrapper>
  )
}
